import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router'
import shopInfo from './dashboards/shopInfo.vue';
import shopsList from './dashboards/shopsList.vue';
import performance from './dashboards/performance.vue';
import board from './dashboards/board.vue';
import postList from './dashboards/postList.vue';
import postLocationList from './dashboards/postLocationList.vue';
import locationGmap from './dashboards/locationGmap.vue';
import userList from './dashboards/userList.vue';
import postEditor from './dashboards/postEditor.vue';
import pagedOrders from './dashboards/PagedOrders.vue';
import orderDetail from './dashboards/OrderDetail.vue';
import appStart from './dashboards/appStart.vue';
import shopSettings from './dashboards/shopSettings.vue';
import apis from './api/extApi.js';
import lang, {getLanguage} from './api/lang.js';

let apiClient = apis.api;

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(Vuex);

var _listenerRef = {
    onRequest:null,
    onReturnRef:{

    },
    onShare: null,
    onPromptLogin: null,
    onLogoutListener: null,
    //onLogout: onLogout,
};

const routes = [
    {
        name: 'Board', path: "/", component: board
    },
    {
        name: 'ShopList', path: "/ShopList", component: shopsList
    },
    {
        name: 'ShopSettings', path: "/ShopSettings", component: shopSettings,props: (route) => ({
            userId: route.query.userId
        })
    },
    {
        name: 'ShopInfo', path: "/ShopInfo", component: shopInfo, props: (route) => ({
            shopUserId: route.query.shopUserId
        })
    },
    {
        name: 'Performance', path: "/Performance", component: performance, props: (route) => ({
            shopUserId: route.query.shopUserId
        })
    },
    // {
    //     name: 'PostList', path: "/PostList", component: postList, props: (route) => ({
    //         userId: route.query.shopUserId
    //     })
    // },
    {
        name: 'PostList', path: "/PostList", components: {
            cachePostList: postList
        },
        props: {
            cachePostList: (route) => ({
                userId: route.query.shopUserId
            })
        }
    },
    {
        name: 'Location', path: "/Location", components: {
            cachePostList: postLocationList
        },
        props: {
            cachePostList: (route) => ({
                userId: route.query.shopUserId
            })
        }
    },
    {
        name: 'Gmap', path: "/Gmap", component: locationGmap, props: (route) => ({
            userId: route.query.shopUserId,
            latLng:{lat:parseFloat(route.query.lat), lng:parseFloat(route.query.lng)}
        })
    },
    {
        name: 'PostList', path: "/PostList", component: postList, props: (route) => ({
            userId: route.query.shopUserId
        })
    },
    {
        name: 'PostEditor', path: "/PostEditor", 
        beforeEnter(to, from, next) {
            setListingPosition('PostList', to, from, next);
        },
        component: postEditor, props: (route) => ({
            editPostId: route.query.editPostId,
            userId: route.query.shopUserId
        })
    },
    {
        name: 'UserList', path: "/UserList", component: userList, props: (route) => ({
            userId: route.query.shopUserId
        })
    },
    {
        name: 'Orders', path: "/Orders", component: pagedOrders, props: (route) => ({
            userId: route.query.shopUserId
        })
    },
    {
        name: 'orderDetail', path: "/orderDetail", component: orderDetail, props: (route) => ({
            orderId: route.query.orderId
        })
    },
];

//scrollBehavior handling
var _scApi = (function () {
    var _onScrollListeners = [];
    var _onScrollApi = {
        on: function (listener) {
            _onScrollListeners.push(listener);
        },
        remove: function (listener) {
            var index = _onScrollListeners.indexOf(listener);
            if (index >= 0) {
                _onScrollListeners.splice(index, 1);
            }
        },
        listeners: _onScrollListeners
    };

    return _onScrollApi;
})();


var listingPosition = { x: 0, y: 0 };
function onScrollResolve(resolve, to, from, savedPosition) {
    for (var i = 0; i < _scApi.listeners.length; i++) {
        var cbs = _scApi.listeners[i];
        if (cbs.onScrollResolve) {
            cbs.onScrollResolve(resolve, listingPosition,  to, from, savedPosition);
        }
    }
}
function setListingPosition(listPageName, to, from, next) {
    for (var i = 0; i < _scApi.listeners.length; i++) {
        var cbs = _scApi.listeners[i];
        if (cbs.onKeepPosition) {
            listingPosition.y = cbs.onKeepPosition(listPageName, to, from, next);
        }
    }
    next();
}
//end scrollBehavior handling

var router = new VueRouter({
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        //document.querySelector("#app").scrollTop = 0;
        return new Promise(resolve => {
            setTimeout(() => {
                onScrollResolve(resolve, to, from, savedPosition);
            }, 50);
        });
    }
});

//var onPromptLogin = null;

const store = new Vuex.Store({
    state: {
        lang:lang,
        account: null,
        showingLogin: false,
        dashProfile: null,
        configs:{layout:{"appVersion":"","layoutName":"LayoutVersion2","background":"red"}}
    },
    mutations: {
        setLang(state,payload){
            state.lang = payload;
        },
        setAccount(state, payload) {
            state.account = payload;
        },
        setDashProfile(state, payload) {
            state.dashProfile = payload;
        },
        setShowLogin(state, payload) {
            state.showingLogin = payload;
        }
    },
    getters: {
        lang: state => {
            return state.lang;
        },
        account: state => {
            return state.account;
        },
        showingLogin: state => {
            return state.showingLogin;
        },
        dashProfile: state => {
            return state.dashProfile;
        },
        configs:state => {
            return state.configs;
        }
    }
});

var mxnApis = {
    data: function () {
        return {
            mxnAgxScrollApi: _scApi
        }
    },
    methods:{
        mxnPromptLogout:function(){
            window.dashVueInst.promptLogout();
        },
        mxnPromptShare:function(shareContent){
            if(_listenerRef.onShare){
                _listenerRef.onShare(shareContent);
            }
        },
        mxnRequestPrm:function(payload){
            var reqId = "REQ"+Date.now();
            console.log("request reqId",reqId);
            var prm = new Promise((resolve)=>{
                _listenerRef.onReturnRef[reqId] = resolve;
                if(_listenerRef.onRequest){
                    _listenerRef.onRequest({payload, reqId});
                }
            });
            return prm;
        }
    }
};

Vue.mixin(mxnApis);//goes to all component

window.dashVueInst = new Vue({
    store: store,
    components: {
        appStart: appStart
    },
    data: function () {
        return {

        };
    },
    methods: {
        getDashProfilePrms: function () {
            return apiClient.getDashProfilePrms().done((e) => {
                console.log("new dashProfile", e);
                var dProfile = e.value;
                if (e.ok) {
                    store.commit("setDashProfile", dProfile);
                    store.commit("setAccount", dProfile.accountUser);
                    var backendLang = getLanguage(dProfile.language === 0?"English":"Chinese");
                    store.commit("setLang", backendLang);

                    if (dProfile.isAgent && !(dProfile.isManager || dProfile.isAdmin || dProfile.isShopKeeper)) {
                        this.$router.push({ path: "/ShopInfo/?shopUserId=" + dProfile.accountUser.userId });
                    } else if (dProfile.isManager || dProfile.isAdmin || dProfile.isShopKeeper) {
                        console.log('current routename', this.$router);
                    }

                } else {
                    store.commit("setDashProfile", null);
                    store.commit("setAccount", null);
                }
            });
        },
        loadProfile:function(){
            console.log('loading profile');
            this.getDashProfilePrms();
        },
        clearProfile: function () {
            store.commit("setAccount", null);
        },
        setResponse:function(ret,req){
            var reqId = req.reqId;
            var resolve = _listenerRef.onReturnRef[reqId];
            if(resolve){
                resolve(ret);
            }
        },
        setPromptRequest:function(req){
            _listenerRef.onRequest = req;
        },
        setPromptShare: function (listener) {
            _listenerRef.onShare = listener;
        },
        setPromptLogin: function (listener) {
            _listenerRef.onPromptLogin = listener;
        },
        setPromptLogout: function (listener) {
            _listenerRef.onLogoutListener = listener;
        },
        showLogin: function (toShow) {
            console.log('toShow', toShow);
            if (_listenerRef.onPromptLogin !== null) {
                _listenerRef.onPromptLogin();
            } else {
                store.commit("setShowLogin", toShow);
            }
        },
        promptLogout:function(){
            console.log('lougout');
            if (_listenerRef.onLogoutListener !== null) {
                _listenerRef.onLogoutListener();
            } else {
                this.clearProfile();
                window.location.href="/Account/Logout"
            }
        }
    },
    created: function () {
    },
    mounted: function () {

    },
    router: router,
    el: "#app"
});

dashVueInst.setPromptShare((shareContent)=>{
    console.log('sharing',shareContent);
    if (navigator.share) {
        try {
             navigator.share({
                title: 'Share',
                text: '',
                url: shareContent.url,
            });
        } catch (err) {
            console.log('Error sharing: ', err);
        }
    } else {
        console.log('Web Share API not supported in this browser.');
    }
});